(() => {
  if (window.mdcVideoSurfaceInitialized) return;
  window.mdcVideoSurfaceInitialized = true;
  let gesture = null;

  const configurePresentationSpeed = (video) => {
    if (!(video instanceof HTMLVideoElement) || !video.closest('mdc-product-video, .mdc-product-video, mdc-story-video, .product-media--color-illustration')) return;
    const duration = video.duration;
    if (!Number.isFinite(duration) || duration <= 6) return;
    const rate = Math.min(4, duration / 6);
    if (video.playbackRate < rate) video.playbackRate = rate;
  };

  document.addEventListener('loadedmetadata', event => {
    const video = event.target;
    queueMicrotask(() => configurePresentationSpeed(video));
  }, true);
  document.addEventListener('playing', event => configurePresentationSpeed(event.target), true);

  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented || !(event.target instanceof Element)) return;
    const scene = event.target.closest('.mdc-product-video__scenes button[data-scene]');
    const owner = scene?.closest('mdc-product-video');
    if (!owner || scene.disabled || owner.failed || typeof owner.startPlayback !== 'function') return;
    owner.manualPaused = false;
    owner.autoplayBlocked = false;
    owner.startPlayback(true);
  });

  document.querySelectorAll('mdc-product-video video, .mdc-product-video video, mdc-story-video video, .product-media--color-illustration video').forEach(configurePresentationSpeed);

  document.addEventListener('pointerdown', event => {
    if (!event.isTrusted) return;
    if (event.isPrimary === false) {
      if (gesture) gesture.moved = true;
      return;
    }
    gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
  }, true);

  document.addEventListener('pointermove', event => {
    if (gesture?.id === event.pointerId &&
        Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 12) gesture.moved = true;
  }, { capture: true, passive: true });

  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented || event.detail === 0 ||
        !(event.target instanceof Element)) return;
    const target = event.target;
    if (target.closest('a, button, input, select, textarea, summary, [role="button"], [role="slider"]')) return;
    const momentFrame = target.closest('mdc-video-moments .mdc-video-moments__frame');
    const storyFrame = target.closest('mdc-story-video .mdc-reviewed-video__viewport, mdc-story-video.mdc-story-video');
    const video = target.closest('video') || momentFrame?.querySelector('video') || storyFrame?.querySelector('video');
    if (!(video instanceof HTMLVideoElement) || (!video.paused && !video.ended)) return;
    const bounds = video.getBoundingClientRect();
    if (video.controls && event.clientY >= bounds.bottom - 54) return;
    const moved = gesture && (gesture.moved || Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 12);
    gesture = null;
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const owner = video.closest('mdc-product-video, mdc-story-video');
    const control = momentFrame?.querySelector('[data-moment-control]') ||
      owner?.querySelector('.mdc-product-video__toggle, .mdc-story-video__toggle');
    if (owner || momentFrame) {
      if (!(control instanceof HTMLButtonElement) || control.disabled || control.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      control.click();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const deferred = video.closest('deferred-media');
    if (typeof deferred?.playMedia === 'function') {
      deferred.playMedia();
    } else {
      if (video.error) video.load();
      const playback = video.play();
      playback?.catch(() => {});
    }
  }, true);
})();


